import { Injectable } from '@angular/core';
import { Desk } from '../model/interfaces/desk.interface';
import { StaticDataService } from 'src/app/static-data/services/static-data.service';
import { STATIC_DATA_TYPE } from 'src/app/static-data/models/consts/static-data.enum';
import { Observable } from 'rxjs';
import { Contact } from '../model/interfaces/contact.interface';

@Injectable({
  providedIn: 'root',
})
export class ContactInformationService {
  private desks: Desk[] = [];
  private contacts: Contact[] = [];

  constructor(private staticDataService: StaticDataService) {}

  getDesks(): Observable<Desk[]> {
    return this.staticDataService.getData(
      STATIC_DATA_TYPE.DESKS
    ) as unknown as Observable<Desk[]>;
  }

  getContacts(): Observable<Contact[]> {
    return this.staticDataService.getData(
      STATIC_DATA_TYPE.CONTACTS
    ) as unknown as Observable<Contact[]>;
  }
}
